module.exports = __webpack_public_path__ + "assets/8fb5d48226cb0573c6631389adc2c073.png";